import getAxiosInstance from "../../../common/mhiAxios";

export default {
    // ディレクトリ一覧取得
    getDir(parentId: number, userId: number): Promise<any> {
        return getAxiosInstance()
            .get("/api/getDir", { params: { id: parentId, userId: userId } })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ディレクトリ作成
    createDir(parentId: number, name: string, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/createDir", { parentId: parentId, name: name, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ディレクトリ名変更
    renameDir(parentId: number, name: string, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/renameDir", { id: parentId, newName: name, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // ディレクトリ削除
    deleteDir(id: number, isForce: boolean, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/deleteDir", { id: id, isForce: isForce, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // フッテージアップロード
    uploadFootage(
        footageFile: File,
        name: string,
        directoryId: number,
        userId: number
    ): Promise<any> {
        const params = new FormData();
        params.append("videoData", footageFile);
        params.append("name", name);
        params.append("directoryId", String(directoryId));
        params.append("userId", String(userId));

        return getAxiosInstance()
            .post("/api/uploadFootage", params, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // フッテージ名変更
    renameFootage(id: number, name: string, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/renameFootage", { id: id, newName: name, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // フッテージ削除
    deleteFootage(id: number, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/deleteFootage", { id: id, userId: userId })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
